import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import {
  NgbCollapseModule,
  NgbDatepickerModule,
  NgbDropdownModule,
  NgbTimepickerModule
} from "@ng-bootstrap/ng-bootstrap";
import { CountToDirective } from "./count-to.directive";
import { PageTitleComponent } from "./page-title/page-title.component";
import { PreloaderComponent } from "./preloader/preloader.component";
import { SlimScrollDirective } from "./slimscroll.directive";

@NgModule({
  declarations: [SlimScrollDirective, CountToDirective, PreloaderComponent, PageTitleComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgbDropdownModule
  ],
  exports: [SlimScrollDirective, CountToDirective, PreloaderComponent, PageTitleComponent]
})
export class UIModule {}
